<div *ngIf="has" class="button__clean__filter" (click)="clean()">
  {{ 'general.cleanFilters' | translate }}
</div>
